import React from 'react';
import PropTypes from 'prop-types';
import { readdirSync, readFileSync } from 'fs';
import useTranslation from 'next-translate/useTranslation';
import each from 'lodash/each';
import Layout from '../../components/Layout';
import PageSearch from '../../components/PageSearch';
import getCanonicalUrl from '../../utils/getCanonicalUrl';
import getSettings from '../../buildArtifacts/settings';

export const SearchPropTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  searchImages: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  seo: PropTypes.object.isRequired,
  canonicalUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  settingsGlobal: PropTypes.object.isRequired
};

const Search = ({ seo, searchImages, canonicalUrl, settingsGlobal }) => {
  const { t } = useTranslation();
  const layoutSeo = { ...seo };
  layoutSeo.description.value = t('common:searchPageDescriptionMetadata');
  layoutSeo.keywords.value = t('common:searchPageKeywordsMetadata');
  return (
    <Layout seo={seo} pageTitle={t('common:searchPageTitleMetadata')} canonicalUrl={canonicalUrl} showFooter settingsGlobal={settingsGlobal}>
      <PageSearch searchImages={searchImages} />
    </Layout>
  );
};

const flattenImages = (fields) => {
  const result = {};
  Object.keys(fields).forEach((key) => {
    const url = fields[key] && fields[key].url;
    if (url) {
      result[key] = url;
    }
  });

  return result;
};

export const getStaticPaths = async ({ locales }) => ({
  paths: locales.map((locale) => ({ params: { slug: [''] }, locale })),
  fallback: false
});

export const getStaticProps = async ({ locale }) => {
  const settingsGlobal = getSettings(locale);
  let searchImages = [];

  const dirName = `./src/buildArtifacts/contentJson/${locale}/searchAssets/`;
  const fileNames = readdirSync(dirName);

  each(fileNames, (fileName) => {
    try {
      const searchAssetsContent = readFileSync(dirName + fileName, 'utf-8');
      searchImages = flattenImages(JSON.parse(searchAssetsContent));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  });

  const canonicalUrl = getCanonicalUrl(null, locale, 'search');

  return {
    props: {
      searchImages,
      canonicalUrl,
      seo: {
        description: { name: 'description', value: 'Search the Dropbox LMS' },
        keywords: { name: 'keywords', value: 'search' },
        content_type: { name: 'content_type', value: 'pageLanding' }
      },
      settingsGlobal
    }
  };
};

Search.propTypes = SearchPropTypes;

export default Search;
